import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const scormInitializedAtom = atom<boolean | undefined>(undefined);
export const scormDebugAtom = atomWithStorage<boolean>('scorm_debug', false);
export const scormPreferedLanguage = atom<string | undefined>(undefined);

export const prospectFlowAtom = atom<boolean | undefined>(undefined);
